/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AcceptFacultyInviteBody } from '../models';
// @ts-ignore
import type { AcceptFacultyInviteResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { FacultyInvitePreviewResponse } from '../models';
/**
 * FacultyInviteApiApi - axios parameter creator
 */
export const FacultyInviteApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AcceptFacultyInviteBody} acceptFacultyInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteApiAcceptFacultyInvite: async (acceptFacultyInviteBody: AcceptFacultyInviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptFacultyInviteBody' is not null or undefined
            assertParamExists('facultyInviteApiAcceptFacultyInvite', 'acceptFacultyInviteBody', acceptFacultyInviteBody)
            const localVarPath = `/api/v1/faculty-invites/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptFacultyInviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteApiPreviewFacultyInvite: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('facultyInviteApiPreviewFacultyInvite', 'token', token)
            const localVarPath = `/api/v1/faculty-invites/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FacultyInviteApiApi - functional programming interface
 */
export const FacultyInviteApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FacultyInviteApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AcceptFacultyInviteBody} acceptFacultyInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyInviteApiAcceptFacultyInvite(acceptFacultyInviteBody: AcceptFacultyInviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AcceptFacultyInviteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyInviteApiAcceptFacultyInvite(acceptFacultyInviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyInviteApiApi.facultyInviteApiAcceptFacultyInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyInviteApiPreviewFacultyInvite(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacultyInvitePreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyInviteApiPreviewFacultyInvite(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyInviteApiApi.facultyInviteApiPreviewFacultyInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FacultyInviteApiApi - factory interface
 */
export const FacultyInviteApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FacultyInviteApiApiFp(configuration)
    return {
        /**
         * 
         * @param {FacultyInviteApiApiFacultyInviteApiAcceptFacultyInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteApiAcceptFacultyInvite(requestParameters: FacultyInviteApiApiFacultyInviteApiAcceptFacultyInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AcceptFacultyInviteResponse> {
            return localVarFp.facultyInviteApiAcceptFacultyInvite(requestParameters.acceptFacultyInviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyInviteApiApiFacultyInviteApiPreviewFacultyInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteApiPreviewFacultyInvite(requestParameters: FacultyInviteApiApiFacultyInviteApiPreviewFacultyInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<FacultyInvitePreviewResponse> {
            return localVarFp.facultyInviteApiPreviewFacultyInvite(requestParameters.token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for facultyInviteApiAcceptFacultyInvite operation in FacultyInviteApiApi.
 */
export interface FacultyInviteApiApiFacultyInviteApiAcceptFacultyInviteRequest {
    readonly acceptFacultyInviteBody: AcceptFacultyInviteBody
}

/**
 * Request parameters for facultyInviteApiPreviewFacultyInvite operation in FacultyInviteApiApi.
 */
export interface FacultyInviteApiApiFacultyInviteApiPreviewFacultyInviteRequest {
    readonly token: string
}

/**
 * FacultyInviteApiApi - object-oriented interface
 */
export class FacultyInviteApiApi extends BaseAPI {
    /**
     * 
     * @param {FacultyInviteApiApiFacultyInviteApiAcceptFacultyInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyInviteApiAcceptFacultyInvite(requestParameters: FacultyInviteApiApiFacultyInviteApiAcceptFacultyInviteRequest, options?: RawAxiosRequestConfig) {
        return FacultyInviteApiApiFp(this.configuration).facultyInviteApiAcceptFacultyInvite(requestParameters.acceptFacultyInviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyInviteApiApiFacultyInviteApiPreviewFacultyInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyInviteApiPreviewFacultyInvite(requestParameters: FacultyInviteApiApiFacultyInviteApiPreviewFacultyInviteRequest, options?: RawAxiosRequestConfig) {
        return FacultyInviteApiApiFp(this.configuration).facultyInviteApiPreviewFacultyInvite(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }
}

